<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Информация о совете дня</span>
      </div>

      <div class="content">
        <div class="content__title">Заголовок</div>
        <div class="content__text">{{ push.push_title }}</div>

        <div class="content__title">Текст совета дня</div>
        <div class="content__text">{{ push.push_body }}</div>

        <div class="content__title">Дата</div>
        <div class="content__text">{{ push.screen && push.screen.title }}</div>

        <div class="content__title">Дата</div>
        <div class="content__text">
          {{ $root.dateDefault(push.send_at) || '-' }} <span class="content__text_gray"><i class="el-icon-time"></i> {{ $root.timeDefault(push.send_at) }}</span>
        </div>

        <div class="content__title">Отправитель</div>
        <div class="content__text">{{ push.admin_email }}</div>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'cpanel.tipDay.item',
  data () {
    return {
      push: {},
      loading: true,
      error: null
    }
  },
  created () {
    this.loading = true
    this.loadLogic()
  },
  computed: {
    getId () {
      return this.$route.params.id
    },
    getQuestionsCascader () {
      const options = this.findQuestions(this.push.questionnaire_list_id).questions
      if (!options) return []

      const fun = (options) => options.map(item => {
        return {
          value: item.id,
          label: item.schema.text,
          ...(item.children.length && { children: fun(item.children) })
        }
      })
      return fun(options)
    },
    getQuestions () {
      if (!this.push.questionnaire || !this.push.questionnaire.questions) return []
      return this.push.questionnaire.questions.filter(element => element.selected)
    }
  },
  components: {},
  methods: {
    loadLogic () {
      this.$api.push
        .view(this.getId)
        .then((response) => {
          this.push = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки модели',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    findQuestions (id) {
      if (!this.push.questionnaire && !this.push.questionnaire.questions.length) return []
      return this.push.questionnaire.questions.find(element => element.id === id)
    }

  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #303133;
  }
}

.content {
  font-size: 14px;
  line-height: 22px;

  &__title {
    margin-top: 24px;
    font-weight: bold;
    color: #303133;
  }

  &__text {
    margin-top: 6px;
    color: #303133;

    &_gray {
      font-size: 14px;
      color: #8E8E93;
    }
  }
}

.tag-container {
  display: inline-block;

  &__tag {
    margin: 5px 10px 0 0;
    display: inline-block;
    font-size: 14px;

    padding: 5px 8px;
    background: #43D3B3;
    border: 1px solid rgba(67, 211, 179, 0.4);
    box-sizing: border-box;
    border-radius: 4px;
    color: #fff;
  }
  &__tag_children {
    margin: 5px 10px 0 0;
    font-size: 14px;

    padding: 5px 8px;
    background: darken(#43D3B3, 10);
    border: 1px solid darken(rgba(67, 211, 179, 0.4), 10);
    box-sizing: border-box;
    border-radius: 4px;
    color: #fff;
  }
}

</style>
